import React from 'react';
// import PropTypes from 'prop-types'

// Components
import ProductImage from 'Components/commonOrder/ProductImage';
import {T} from 'Actions/translate';
import {USER_ROLE, OrderTypeEnum} from 'Utils/constant';
import BasicButton from 'Components/common/BasicButton';

class ProductItem extends React.Component {
    showAssayIdContent = (product) => {
        const {roleType} = this.props;
        let showAssayIdContentFlag = false;
        if (
            (roleType === USER_ROLE.SALES ||
                roleType === USER_ROLE.ADMIN ||
                roleType === USER_ROLE.HOST) &&
            product &&
            product.displayAttributeList &&
            product.displayAttributeList.length > 0
        ) {
            showAssayIdContentFlag = true;
        }
        return showAssayIdContentFlag;
    };
    render() {
        const {
            item,
            className,
            inventoryKey,
            orderType,
            roleType,
            showCrd,
            showSalesShippingPlanTip,
            showInventoryDetail,
            inventoryDetailAction,
        } = this.props;

        return (
            <div className={className}>
                <div
                    className={
                        item.haveShippingPlan
                            ? 'image-box have-shipping-plan'
                            : 'image-box'
                    }>
                    <ProductImage
                        src={item.product && item.product.productPic}
                        alt={item.product && item.product.productName}
                    />
                </div>
                <div className="details">
                    <p
                        className="product-name"
                        testid={item.product && item.product.productName}
                        dangerouslySetInnerHTML={{
                            __html: item.product.productName,
                        }}
                    />
                    <div style={{display: 'flex'}}>
                        <p className="sku row text-ellipsis">
                            <label>{T('product_sku_colon')} </label>
                            <span title={item.product.sku}>
                                {item.product.sku}
                            </span>
                        </p>
                        {orderType === 'SCM' ? (
                            <p
                                className="inventory row text-ellipsis"
                                style={{marginLeft: '10px'}}>
                                <label>{T('order_inventory_colon')} </label>
                                {item.productSupplyCenter ? (
                                    <span>
                                        {inventoryKey === 'displayInventory' &&
                                        item.productSupplyCenter[inventoryKey] <
                                            0
                                            ? 0
                                            : item.productSupplyCenter[
                                                  inventoryKey
                                              ]}
                                    </span>
                                ) : null}
                            </p>
                        ) : null}
                        {showInventoryDetail && (
                            <BasicButton
                                type="info"
                                className="cancel-btn product-inventory-detail-btn"
                                onClickOfSingleTap={inventoryDetailAction}>
                                {T('fone_order_inventory_details')}
                            </BasicButton>
                        )}
                    </div>
                    <p className="specification row text-ellipsis">
                        <label>{T('product_specifications_colon')} </label>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: item.product.specifications,
                            }}
                        />
                    </p>
                    {/* <p className="specification row text-ellipsis">
                        <label>{T('product_specifications_colon')} </label>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: item.product.specifications,
                            }}
                        />
                    </p> */}
                    {/* <p className="text-ellipsis row"><label>存储条件: </label><span>{ item.product.storeCondition }</span></p> */}

                    {this.showAssayIdContent(item.product) && (
                        <div className="assayid-content-wrapper">
                            {item.product.displayAttributeList.map(
                                (assayIdItem, assayIdIndex) => (
                                    <div
                                        className="assayIdArea"
                                        key={assayIdIndex}>
                                        <label
                                            style={{
                                                marginRight: '5px',
                                            }}>
                                            {assayIdItem.displayName}:
                                        </label>
                                        <span className="assayIdLabel">
                                            {assayIdItem.displayValue}
                                        </span>
                                    </div>
                                ),
                            )}
                        </div>
                    )}
                    <div style={{marginTop: '4px'}}></div>
                    {item.crd &&
                        showCrd &&
                        orderType !== OrderTypeEnum.SO &&
                        orderType !== OrderTypeEnum.SE && (
                            <div className="crd-container">
                                <div className="crd-wrapper">
                                    <span>
                                        <span>{T('product_crd_date')}</span>
                                    </span>
                                    <span style={{marginLeft: '8px'}}>
                                        {item.crd}
                                    </span>
                                </div>
                                {showSalesShippingPlanTip && (
                                    <div className="sales-shipping-plan-tip">
                                        {T('sales_shipping_plan_sync_reminder')}
                                    </div>
                                )}
                            </div>
                        )}
                    {roleType !== 'undefined' &&
                        roleType !== 0 &&
                        item.estimatedShippingDate &&
                        roleType !== USER_ROLE.HOST && (
                            <div
                                style={{
                                    marginTop: '4px',
                                    fontSize: '13px',
                                    textAlign: 'right',
                                    display: 'flex',
                                    color: '#b1b1b1',
                                }}>
                                <label>
                                    {T('product_estimated_ship_date')}
                                </label>
                                <div
                                    style={{
                                        marginLeft: '8px',
                                    }}>
                                    {item.estimatedShippingDate}
                                </div>
                            </div>
                        )}
                </div>
                {this.props.children}
            </div>
        );
    }
}

ProductItem.defaultProps = {
    inventoryKey: 'displayInventory',
    orderType: 'SCM',
};

export default ProductItem;
